<script>
import getSecret from '@utils/get-secret'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      // return title ? `${title} | ${getSecret('TITLE')}` : getSecret('TITLE')
      return title || getSecret('TITLE')
    },
  },
  data() {
    return {
      installBtn: false,
      installer: undefined,
      environment: process.env.ENVIRONMENT,
      registration:null,
      isRefresh: false,
      refreshing: false,
    };
  },
  created() {
    document.addEventListener(
        'serviceWorkerUpdateEvent', this.appUpdateUI, { once: true }
    );

     navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return;
          this.refreshing = true;
          window.location.reload();
        }
    );

    let installPrompt;
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      installPrompt = e;
      this.installBtn = true;
    });

    this.installer = () => {
      this.installBtn = false;
      installPrompt.prompt();
      installPrompt.userChoice.then(result => {
        console.log("installPrompt", result)
        if (result.outcome === "accepted") {
          console.log("Install accepted!")
        } else {
          console.log("Install denied!")
        }
      });
    };
  },
  methods:{
    appUpdateUI:function (e){
      this.registration = e.detail;
      this.isRefresh = true;
    },
    update(){
     this.isRefresh = false;
     if (this.registration || this.registration.waiting) {
       this.registration.waiting.postMessage({type:'SKIP_WAITING'});
     }
   },
  },
  computed: {
    innerWidth(){
      return window.innerWidth
    }
  }
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
    <b-button v-if="installBtn && environment !== 'development' && innerWidth <= 840" block variant="info" size="lg" @click="installer()">
      <b-icon-download class="mr-1" /> Instalar Aplicación
    </b-button>
    <!-- <b-button v-if="isRefresh && environment !== 'development'" block variant="info" size="lg" @click="update">
      <b-icon-upload class="mr-1" /> Actualizar
    </b-button> -->
    <notifications group="foo" classes="custom-vue-notification" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Design variables and utilities from src/design.
  @import '@design';
</style>
